import type { FunctionComponent } from 'react';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { capitalize } from 'string-ts';

import type { DisplayableMetricType } from '../types';
import { Card, CardContent, CardHeader } from '@/components';
import { PIE_COLORS } from '../constants';

export const TrafficSourcesChart: FunctionComponent<{
  trafficSources: DisplayableMetricType[];
}> = ({ trafficSources }) => (
  <Card className="h-full w-1/2 2xl:!h-1/2 2xl:!w-full">
    <CardHeader className="px-6 pb-2 pt-4 font-bold">Traffic Sources</CardHeader>

    <CardContent className="mt-auto h-4/5 w-full p-2">
      {trafficSources.length > 0 ? (
        <ResponsiveContainer width="90%" height="100%">
          <PieChart>
            <Pie
              data={trafficSources}
              dataKey="value"
              nameKey="label"
              innerRadius={30}
              outerRadius={48}
              startAngle={90}
              endAngle={450}
              width="35%"
              className="focus:outline-none"
            >
              {trafficSources.map((_, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={PIE_COLORS[index % PIE_COLORS.length]}
                  stroke="#ffffff"
                  strokeWidth={2}
                />
              ))}
            </Pie>
            <Legend
              layout="vertical"
              align="right"
              verticalAlign="middle"
              wrapperStyle={{ width: '65%', maxHeight: '100%' }}
              content={({ payload }) => (
                <div className="flex w-full flex-col space-y-1 text-sm 2xl:ml-6">
                  {payload?.map((entry, index) => (
                    <div key={`item-${index}`} className="flex w-full items-center">
                      <span
                        className="mr-2 h-2 w-2 shrink-0 rounded-full"
                        style={{
                          backgroundColor: PIE_COLORS[index % PIE_COLORS.length],
                        }}
                      />
                      <div className="grid w-full grid-cols-[1fr_3.5rem] items-center gap-3">
                        <span
                          className="min-w-0 flex-1 whitespace-nowrap text-sm text-gray-500"
                          title={capitalize(entry.value)}
                        >
                          {capitalize(entry.value)}
                        </span>
                        <span className="w-14 text-right text-[14px] font-semibold">
                          {entry.payload?.value}%
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            />
          </PieChart>
        </ResponsiveContainer>
      ) : (
        <div className="flex h-full w-full items-center justify-center">
          <p>No Traffic Sources Data Available</p>
        </div>
      )}
    </CardContent>
  </Card>
);
